import React from "react";
import { Button, ControlLabel, FormControl, Alert, Modal } from "react-bootstrap";
import TCClockEditItem from "./tc-clock-edit-item.jsx";
import moment from "moment";
import immutable from "immutable";

import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import LogWorkForm from "./../shared/log-work-form.jsx";
import TimecardLineCopy from "./../shared/tc-line-copy.jsx";

export default class TCClockEditItemGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showLogWorkDlg: false,
            work: {
                mode: "add"
            },
            saveWorkErrors: null
        };

        this.validateTimecard = this.validateTimecard.bind(this);
        this.onOpenLogWork = this.onOpenLogWork.bind(this);
        this.onCloseLogWork = this.onCloseLogWork.bind(this);
        this.saveWork = this.saveWork.bind(this);
        this.onOpenTcLineCopy = this.onOpenTcLineCopy.bind(this);

        console.log(props);
    }

    validateTimecard() {
        let errors = [];
        let vm = this.props.vm;
        if (vm.isIncomplete) {
            let workdays = vm.incompleteWorkdays.map(wd => moment(wd).format("M/D/YYYY"));
            if (workdays.length > 0) {                
                errors.push(`Incomplete timeclock exists (Timecard ID: ${vm.timecard.timecardId}, Work Date: ${workdays.join(", ")})`);
            }            
        }
        return errors;
    }

    onOpenLogWork() {
        if (this.props.vm.placementTasks == null || this.props.vm.placementTasks.length == 0) {
            context.message({
                show: true,
                type: "error",
                message: "Placement tasks are missing. Please contact Help Desk",
                buttons: "ok"
            });
            return false;
        }
        
        this.refs.logWorkForm.openNew();
    }


    saveWork() {
        context.message({
            show: true,
            type: "loading",
            message: "Logging work. Please wait..."
        });
        let self = this;
        this.state.work.timecardId = this.props.vm.timecard ? this.props.vm.timecard.timecardId : null;

        ajax.api()
            .post("log-work", this.state.work)
            .then(function (res) {
                let clone = immutable.fromJS(self.state).toJS();
                clone.saveWorkErrors = null;
                clone.showLogWorkDlg = false;
                self.setState(clone);
                if (self.props.onLogWork) self.props.onLogWork(res);
                else {
                    context.message({
                        show: false,
                    });
                }
            })
            .catch(function (err) {
                console.log(err);
                let map = immutable.fromJS(self.state);
                let data = err.response.data;
                let errors = null;
                let errorItems = [];
                if (data.ClassName === "ActionPortal.ValidationException") {
                    for (let key in data.Data.summary.validationResults) {
                        errorItems.push((
                            <li key={key}>{data.Data.summary.validationResults[key]}</li>
                        ));
                    }
                    errors = (<ul>
                        {errorItems}
                    </ul>);
                } else {
                    errors = data.exceptionMessage || data.message;
                }
                let clone = map.toJS();
                clone.saveWorkErrors = errors;
                self.setState(clone);
                context.message({
                    show: false,
                });
            });
    }

    onCloseLogWork() {
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({ showLogWorkDlg: false }).toJS());
    }

    onOpenTcLineCopy() {
        this.refs.tcLineCopy.open();
    }

    render() {
        const self = this;
        const vm = this.props.vm;
        let errors = this.validateTimecard();
       
        let alertSection = errors.length > 0 ? (
            <div className="col-md-12">
                <Alert bsStyle="danger">
                    <div className="ap-wrap-text">
                        <ul>
                            {errors.map(m => <li key={m}>{m}</li>)}
                        </ul>
                    </div>
                </Alert>
            </div>
        ) : null;

        let totalRegHour = vm.timecard != null ? vm.timecard.regularHour || 0 : 0;
        let totalRegMin = vm.timecard != null ? vm.timecard.regularMin || 0 : 0;
        let totalOTHour = vm.timecard != null ? vm.timecard.otHour || 0 : 0;
        let totalOTMin = vm.timecard != null ? vm.timecard.otMin || 0 : 0;
        let totalDTHour = vm.timecard != null ? vm.timecard.dtHour || 0 : 0;
        let totalDTMin = vm.timecard != null ? vm.timecard.dtMin || 0 : 0;

        let specialBill = null;
        const allowEdit = `${this.props.allowEdit}` == "true";

        return (
            <div className="container">
                <div className="row">
                    {alertSection}
                    <div className="col-xs-12 col-md-4">{
                        vm.enableCopyWorkHours? <Button className={allowEdit ? "btn-info ap-fullsize" : "ap-hidden"}
                                                    onClick={this.onOpenTcLineCopy} disabled={!allowEdit}>Quick Copy</Button> : null }
                    </div>
                    <div className="col-xs-12 col-md-4 ap-mt-1">

                    </div>
                    <div className="col-xs-12 col-md-4">
                        <Button className={allowEdit ? "btn-info ap-fullsize" : "ap-hidden"}
                            onClick={this.onOpenLogWork} disabled={!allowEdit}>Add Work Time</Button>
                    </div>
                    <div className="col-xs-12 col-md-12 ap-top-margined">
                        <div className="ap-border-color-lightgray">
                            <div className="ap-bkg-color-gray ap-color-white ap-summary-container hidden-xs hidden-sm">
                                <div className="ap-work-item-grid-header hidden-xs hidden-sm">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-2">
                                                Date
                                            </div>
                                            <div className="col-md-1">
                                                In
                                            </div>
                                            <div className="col-md-2">
                                                Reason
                                            </div>
                                            <div className="col-md-1">
                                                Out
                                            </div>
                                            <div className="col-md-2">
                                                Reason
                                            </div>
                                            <div className="col-md-1">
                                                Duration
                                            </div>
                                            <div className="col-md-1">
                                                Delete
                                            </div>
                                            <div className="col-md-1">
                                                Edit
                                            </div>
                                            <div className="col-md-1">
                                                {this.props.showAltered ? "Altered" : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ap-work-item-grid-content">
                                {vm.timecardLineDatas.map(tcld => <TCClockEditItem key={tcld.timecardLine.timecardLineId}
                                    onDeleteTcLineDetail={self.props.onDeleteTcLineDetail} onEditTcLineDetail={(tcldId) => {
                                        self.refs.logWorkForm.openUpdate(tcldId);
                                    }} vm={tcld} allowEdit={this.props.allowEdit} showAltered={this.props.showAltered} timecardStatus={vm.timecard.statusCode} />)}
                            </div>
                            <div className="ap-bkg-color-gray ap-color-white ap-summary-container container-fluid">
                                <div className="row">
                                    <div className="col-xs-4 col-sm-4 col-md-2 col-lg-2">
                                        Work Total :
                                    </div>
                                    <div className="col-xs-8 col-sm-8 col-md-3 col-lg-3">
                                        Regular : {totalRegHour} hour(s) {totalRegMin} minute(s)
                                    </div>
                                    <div className="col-xs-offset-4 col-sm-offset-4 col-md-offset-0 col-lg-offset-0 col-xs-8 col-sm-8 col-md-3 col-lg-3">
                                        OT : {totalOTHour} hour(s) {totalOTMin} minute(s)
                                    </div>
                                    <div className="col-xs-offset-4 col-sm-offset-8 col-md-offset-0 col-lg-offset-0 col-xs-8 col-sm-8 col-md-3 col-lg-3">
                                        DT : {totalDTHour} hour(s) {totalDTMin} minute(s)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LogWorkForm onLogWork={this.props.onLogWork}
                    vm={{
                        timecardId: (vm.timecard) ? vm.timecard.timecardId : null,
                        weekDays: vm.weekDays,
                        inReasons: vm.inReasons,
                        outReasons: vm.outReasons,
                        placementTasks: vm.placementTasks,
                        quarterRounding: vm.quarterRounding,
                        disableMealBreakRounding: !!(vm.disableMealBreakRounding)
                    }}
                    ref="logWorkForm"
                    role={self.props.role} />
                <TimecardLineCopy onCopy={this.props.onLogWork}
                    timecardId={(vm.timecard) ? vm.timecard.timecardId : null}
                    ref="tcLineCopy"
                    role={self.props.role} />
            </div>
        );
    }
}